/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to create a financial group
 * @export
 * @interface AddOrUpdateFinancialGroupRequest
 */
export interface AddOrUpdateFinancialGroupRequest {
    /**
     * Unique identifier of the financial group
     * @type {number}
     * @memberof AddOrUpdateFinancialGroupRequest
     */
    id?: number;
    /**
     * The financial group code
     * @type {string}
     * @memberof AddOrUpdateFinancialGroupRequest
     */
    code?: string;
    /**
     * The financial group title
     * @type {string}
     * @memberof AddOrUpdateFinancialGroupRequest
     */
    title?: string;
    /**
     * Indicate if the financial group is active
     * @type {boolean}
     * @memberof AddOrUpdateFinancialGroupRequest
     */
    active?: boolean;
    /**
     * The personal info appearing on the bill
     * @type {string}
     * @memberof AddOrUpdateFinancialGroupRequest
     */
    personalInfo?: string;
    /**
     * Unique identifier of the institute.
     * @type {string}
     * @memberof AddOrUpdateFinancialGroupRequest
     */
    instituteId?: string;
    /**
     * The IBAN of the person
     * @type {string}
     * @memberof AddOrUpdateFinancialGroupRequest
     */
    iban?: string;
    /**
     * The BIC of the person
     * @type {string}
     * @memberof AddOrUpdateFinancialGroupRequest
     */
    bic?: string;
}

/**
 * Check if a given object implements the AddOrUpdateFinancialGroupRequest interface.
 */
export function instanceOfAddOrUpdateFinancialGroupRequest(value: object): value is AddOrUpdateFinancialGroupRequest {
    return true;
}

export function AddOrUpdateFinancialGroupRequestFromJSON(json: any): AddOrUpdateFinancialGroupRequest {
    return AddOrUpdateFinancialGroupRequestFromJSONTyped(json, false);
}

export function AddOrUpdateFinancialGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddOrUpdateFinancialGroupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'title': json['title'] == null ? undefined : json['title'],
        'active': json['active'] == null ? undefined : json['active'],
        'personalInfo': json['personalInfo'] == null ? undefined : json['personalInfo'],
        'instituteId': json['instituteId'] == null ? undefined : json['instituteId'],
        'iban': json['iban'] == null ? undefined : json['iban'],
        'bic': json['bic'] == null ? undefined : json['bic'],
    };
}

export function AddOrUpdateFinancialGroupRequestToJSON(json: any): AddOrUpdateFinancialGroupRequest {
    return AddOrUpdateFinancialGroupRequestToJSONTyped(json, false);
}

export function AddOrUpdateFinancialGroupRequestToJSONTyped(value?: AddOrUpdateFinancialGroupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'title': value['title'],
        'active': value['active'],
        'personalInfo': value['personalInfo'],
        'instituteId': value['instituteId'],
        'iban': value['iban'],
        'bic': value['bic'],
    };
}

